var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "column",
          gap: "12px",
          padding: "32px"
        }
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              "font-size": "24px",
              "font-family": "PingFang SC",
              "font-weight": "bold",
              color: "#333333"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("i18n_Cost")) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-wrap": "wrap",
              "align-items": "center",
              "column-gap": "8px"
            }
          },
          [
            _c(
              "div",
              { staticClass: "bg-purple" },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "14px",
                      "font-family": "PingFang SC",
                      "font-weight": "500",
                      color: "#333333",
                      "margin-right": "8px"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("i18n_cost_generated_time")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("el-date-picker", {
                  attrs: {
                    "value-format": "yyyy-MM-dd",
                    type: "daterange",
                    "range-separator": "-",
                    "start-placeholder": _vm.$t("i18n_started_date"),
                    "end-placeholder": _vm.$t("i18n_end_date")
                  },
                  model: {
                    value: _vm.value1,
                    callback: function($$v) {
                      _vm.value1 = $$v
                    },
                    expression: "value1"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "bg-purple normal",
                staticStyle: { display: "flex", "align-items": "center" }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      width: "56px",
                      "font-size": "14px",
                      "font-family": "PingFang SC",
                      "font-weight": "500",
                      color: "#333333",
                      "margin-right": "8px"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("i18n_Tracking_number")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("el-input", {
                  attrs: {
                    placeholder: _vm.$t("i18n_please_enter"),
                    clearable: ""
                  },
                  model: {
                    value: _vm.nos,
                    callback: function($$v) {
                      _vm.nos = $$v
                    },
                    expression: "nos"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "bg-purple normal",
                staticStyle: { display: "flex", "align-items": "center" }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      width: "76px",
                      "font-size": "14px",
                      "font-family": "PingFang SC",
                      "font-weight": "500",
                      color: "#333333",
                      "margin-right": "8px"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("i18n_Clients_tracking_number")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("el-input", {
                  attrs: {
                    placeholder: _vm.$t("i18n_please_enter"),
                    clearable: ""
                  },
                  model: {
                    value: _vm.customerNo,
                    callback: function($$v) {
                      _vm.customerNo = $$v
                    },
                    expression: "customerNo"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bg-purple normal" },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      width: "76px",
                      "font-size": "14px",
                      "font-family": "PingFang SC",
                      "font-weight": "500",
                      color: "#333333",
                      "margin-right": "8px"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("i18n_bill_status")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: _vm.$t("i18n_please_choose") },
                    model: {
                      value: _vm.state,
                      callback: function($$v) {
                        _vm.state = $$v
                      },
                      expression: "state"
                    }
                  },
                  _vm._l(_vm.statusList, function(item) {
                    return _c("el-option", {
                      key: item.state,
                      attrs: { label: _vm.$t(item.name), value: item.state }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      width: "72px",
                      height: "32px",
                      "line-height": "32px",
                      "margin-left": "20px",
                      padding: "0px"
                    },
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.getListByParams(1)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_Inquiry")))]
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            staticStyle: {
              width: "92px",
              height: "32px",
              "line-height": "32px",
              padding: "0px"
            },
            attrs: { type: "primary" },
            on: {
              click: function($event) {
                return _vm.toPay()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("i18n_combine_payments")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "div",
              { staticStyle: { "max-height": "500px", overflow: "auto" } },
              [
                _c(
                  "table",
                  {
                    staticClass: "basic-table",
                    staticStyle: { width: "100%", border: "1px solid #e7e7e7" }
                  },
                  [
                    _c("thead", [
                      _c(
                        "tr",
                        {
                          staticStyle: {
                            "background-color": "#e7e7e7",
                            height: "35px",
                            "font-size": "12px",
                            "font-family": "PingFang SC",
                            "font-weight": "400",
                            color: "#9a9a9a"
                          }
                        },
                        [
                          _c(
                            "th",
                            {
                              staticStyle: {
                                width: "50px",
                                border: "1px solid #e7e7e7"
                              }
                            },
                            [
                              _c("el-checkbox", {
                                on: {
                                  change: function($event) {
                                    return _vm.allSelected($event)
                                  }
                                },
                                model: {
                                  value: _vm.allSelectValue,
                                  callback: function($$v) {
                                    _vm.allSelectValue = $$v
                                  },
                                  expression: "allSelectValue"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("th", { staticStyle: { width: "50px" } }, [
                            _vm._v(_vm._s(_vm.$t("i18n_Serial_number")))
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.title, function(item, index) {
                            return _c("th", { key: index }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t(item)) +
                                  "\n              "
                              )
                            ])
                          })
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _vm.list.length > 0
                      ? _c(
                          "tbody",
                          { staticStyle: { "text-align": "center" } },
                          _vm._l(_vm.list, function(listItem, listIndex) {
                            return _c(
                              "tr",
                              {
                                key: listIndex,
                                staticStyle: {
                                  "min-height": "40px",
                                  border: "1px solid #e7e7e7"
                                }
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass: "tableBorderMy",
                                    staticStyle: { width: "50px" }
                                  },
                                  [
                                    listItem.show
                                      ? _c("el-checkbox", {
                                          attrs: { value: listItem.checked },
                                          on: {
                                            change: function($event) {
                                              return _vm.allSelectedChange(
                                                $event,
                                                listIndex
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "tableBorderMy" }, [
                                  _vm._v(_vm._s(listIndex + 1))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "tableBorderMy" }, [
                                  _vm._v(_vm._s(listItem.nos))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "tableBorderMy" }, [
                                  _vm._v(_vm._s(listItem.customerNo))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  _vm._l(listItem.detailList, function(
                                    singleItem,
                                    itemIndex
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: itemIndex,
                                        class: {
                                          tableBorderMyBtn: !(
                                            listItem.detailList.length - 1 ==
                                            itemIndex
                                          )
                                        },
                                        staticStyle: {
                                          height: "38px",
                                          "line-height": "38px",
                                          "border-right": "1px solid #e7e7e7"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content": "center"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "text-align": "start"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      width: "16px",
                                                      "margin-right": "7px"
                                                    }
                                                  },
                                                  [
                                                    singleItem.status == 1
                                                      ? _c("el-checkbox", {
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              return _vm.itemSelect(
                                                                $event,
                                                                listIndex,
                                                                itemIndex,
                                                                singleItem.id,
                                                                singleItem.cnyAmount
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              singleItem.checked,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                singleItem,
                                                                "checked",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "singleItem.checked"
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      width: "120px",
                                                      overflow: "hidden",
                                                      "white-space": "nowrap",
                                                      "text-overflow":
                                                        "ellipsis"
                                                    }
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            singleItem.feeName
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  _vm._l(listItem.detailList, function(
                                    singleItem,
                                    itemIndex
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: itemIndex,
                                        class: {
                                          tableBorderMyBtn: !(
                                            listItem.detailList.length - 1 ==
                                            itemIndex
                                          )
                                        },
                                        staticStyle: {
                                          height: "38px",
                                          "line-height": "38px",
                                          "border-right": "1px solid #e7e7e7"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(singleItem.amount) +
                                            " " +
                                            _vm._s(singleItem.currency) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  _vm._l(listItem.detailList, function(
                                    singleItem,
                                    itemIndex
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: itemIndex,
                                        class: {
                                          tableBorderMyBtn: !(
                                            listItem.detailList.length - 1 ==
                                            itemIndex
                                          )
                                        },
                                        staticStyle: {
                                          height: "38px",
                                          "line-height": "38px",
                                          "border-right": "1px solid #e7e7e7"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(singleItem.inputtime) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  _vm._l(listItem.detailList, function(
                                    singleItem,
                                    itemIndex
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: itemIndex,
                                        class: {
                                          tableBorderMyBtn: !(
                                            listItem.detailList.length - 1 ==
                                            itemIndex
                                          )
                                        },
                                        staticStyle: {
                                          height: "38px",
                                          "line-height": "38px",
                                          "border-right": "1px solid #e7e7e7"
                                        }
                                      },
                                      [
                                        singleItem.status == "1"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "i18n_waiting_for_payment"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        singleItem.status == "2"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "i18n_waiting_for_confirmation"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        singleItem.status == "3"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("i18n_completed"))
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        singleItem.status == "4"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "i18n_payment_processing"
                                                  )
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  _vm._l(listItem.detailList, function(
                                    singleItem,
                                    itemIndex
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: itemIndex,
                                        class: {
                                          tableBorderMyBtn: !(
                                            listItem.detailList.length - 1 ==
                                            itemIndex
                                          )
                                        },
                                        staticStyle: {
                                          height: "38px",
                                          "line-height": "38px",
                                          display: "flex",
                                          "justify-content": "center"
                                        }
                                      },
                                      [
                                        singleItem.feeName
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "myCursor",
                                                staticStyle: {
                                                  color: "#9a9a9a"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.getDetail(
                                                      listIndex
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("i18n_fee_details")
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticStyle: { width: "30px" } },
                                          [
                                            singleItem.status == 1
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "myCursor paySpan",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.toPay(
                                                          singleItem.id,
                                                          "1",
                                                          singleItem.cnyAmount
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t("i18n_pay")
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _vm.list.length == 0
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "line-height": "100px",
                          height: "100px",
                          width: "100%",
                          color: "#999",
                          "text-align": "center"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("i18n_No_data")) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-dialog",
                  {
                    staticClass: "Mydialog",
                    attrs: {
                      title: _vm.$t("i18n_fee_details"),
                      visible: _vm.dialogVisible,
                      width: "30%",
                      center: ""
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.dialogVisible = $event
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: {
                              width: "100%",
                              "margin-top": "20px"
                            },
                            attrs: {
                              data: _vm.detail,
                              "header-cell-style": {
                                background: "#eef1f6",
                                color: "#606266"
                              },
                              border: "",
                              align: "center",
                              "highlight-current-row": ""
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "feeName",
                                label: _vm.$t("i18n_Charge_category"),
                                width: "180"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "amount",
                                label: _vm.$t("i18n_Price")
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      scope.row.TotalCnyAmount
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  scope.row.TotalCnyAmount
                                                ) +
                                                " CNY\n                  "
                                            )
                                          ])
                                        : scope.row.TotalCnyAmount1
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  scope.row.TotalCnyAmount1
                                                ) +
                                                "\n                  "
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(scope.row.currency) +
                                                " " +
                                                _vm._s(scope.row.price) +
                                                "\n                  "
                                            )
                                          ])
                                    ]
                                  }
                                }
                              ])
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                prop: "amount2",
                                label: _vm.$t("i18n_fee_details")
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(scope.row.price) +
                                          " " +
                                          _vm._s(scope.row.currency) +
                                          " *\n                  " +
                                          _vm._s(scope.row.piece) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              staticStyle: { "margin-top": "20px", float: "left" },
              attrs: {
                "current-page": _vm.currentPage,
                "page-sizes": [10, 20, 50, 100],
                "page-size": 10,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.total
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange
              }
            }),
            _vm._v(" "),
            _c("div", { staticStyle: { clear: "both" } })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9deb7dd2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9deb7dd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalCenter/billType/Mybill.vue
// module id = null
// module chunks = 